export const SET_DEFAULT_PAYMENT_METHOD = "setDefaultPaymentMethod";